// AddNewServiceForm.js
import React, { useEffect, useState } from "react";
import "./AddNewServiceModal.css"; // Import the CSS for the form
import { get, post } from "../../../utility/fetch2";

const AddFundsToWallet = ({ onClose, wallets, toFund }) => {
  const [serviceName, setServiceName] = useState("");
  const [amount, setAmount] = useState("");
  const [additionalNote, setAdditionalNote] = useState("");
  const userInfo = JSON.parse(localStorage.getItem("USER_INFO"));

  useEffect(() => {
    // fetchMedications()
  }, []);

  const handleSubmit = async (e) => {
    // e.preventDefault();
    // Basic validation
    // if (!serviceName.trim() || !amount.trim()) {
    //   alert('Service Name and Amount are required.');
    //   return;
    // }

    // Call the onSubmit prop with the form data
    console.log({
      serviceName,
      amount: parseFloat(amount), // Convert amount to a number
      additionalNote,
    });

    let payload = {
      walletId: wallets,
      amount: toFund ? parseFloat(amount) : parseFloat(amount),
      transactionType: toFund ? "credit" : "debit",
      description: additionalNote,
      status: "",
    };

    try {
      const response = toFund?await post("/wallet/credit", payload):await post("/wallet/debit", payload)

      console.log(response);
      // Filter for laboratory providers and format for react-select
      // const laboratoryProviders = response.resultList
      //   .filter((lab) => lab.healthCareProviderCategory?.name === "Laboratory")
      //   .map((lab) => ({
      //     value: lab.id,
      //     label: lab.name,
      //     location: lab.location,
      //     phone: lab.phone,
      //     email: lab.email,
      //   }));
      // setLabs(laboratoryProviders);
    } catch (error) {
      console.error("Error fetching laboratories:", error);
      // setLabs([]);
    }

    // Clear form fields
    setServiceName("");
    setAmount("");
    setAdditionalNote("");

    onClose(); // Close the modal after submission
  };

  return (
    <div className="add-service-form-container">
      <div className="form-header">
        <h2>Fund Wallet</h2>
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
      </div>
      <div className="form-body">
        <div className="form-group">
          <input
            type="text"
            id="serviceName"
            className="form-input"
            placeholder="Payment Title"
            value={serviceName}
            onChange={(e) => setServiceName(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <input
            type="number" // Use type="number" for amount
            id="amount"
            className="form-input"
            placeholder="Enter amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            step="0.01" // Allows decimal amounts
            required
          />
        </div>

        <div className="form-group">
          <textarea
            id="additionalNote"
            className="form-textarea"
            placeholder="Additional Note"
            value={additionalNote}
            onChange={(e) => setAdditionalNote(e.target.value)}
            rows="4" // Set initial rows
          ></textarea>
        </div>

        <button onClick={handleSubmit} className="submit-button">
          Submit
        </button>
      </div>
    </div>
  );
};

export default AddFundsToWallet;
